import { Injectable } from '@angular/core';
import {BehaviorSubject, combineLatestWith, Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { ManagementStoreService } from './management-store.service';
import { ManagementApiService } from '@emm/management/services/management-api.service';
import {genericSort} from '@emm/core/util/sort.util';
import {GenericItem} from '@emm/core/models/context-menu-action.model';
import {ItemType} from '@emm/core/models/item-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

@Injectable({
    providedIn: 'root'
})
export class ItemTypesFacadeService {

    itemTypes$ = new BehaviorSubject<any>(undefined);
    itemTypeClasses$ = this.api.getAllItemTypeClasses();
    itemTypeDetail$ = new BehaviorSubject<any>(null);
    updateItemType$ = new BehaviorSubject<any>(null);

    itemTypesAsGenericItems$ = this.itemTypes$.pipe(
        filter(RA.isNotNil),
        map((itemTypes) =>
            itemTypes.sort(genericSort(a => a['name']))
                .map(
                (itemType) =>
                    ({
                        name: itemType.name,
                        tag: itemType.tag,
                        disabled: false,
                        source: itemType,
                    } as GenericItem<ItemType>)
            )
        )
    );

    centerLoading$ = this.managementStore.isLoading$.itemTypes.pipe(
        combineLatestWith(this.managementStore.isLoading$.itemTypeClasses),
        map((sources: boolean[]) => R.any(R.equals(true), sources))
    );

    rightLoading$ = this.managementStore.isLoading$.base;

    anyLoading$ = this.centerLoading$.pipe(
        combineLatestWith(this.rightLoading$),
        map((sources: boolean[]) => R.any(R.equals(true), sources))
    );

    constructor(
        private managementStore: ManagementStoreService,
        public api: ManagementApiService) {}



    init(): void {
        this.managementStore.dispatch.initItemTypes();
    }



    selectItemType(itemType: ItemType): void {
        let itemTypeDetail;
        this.api.getItemType(itemType.tag).subscribe(result => {
            itemTypeDetail = result;
            this.itemTypeDetail$.next(itemTypeDetail[0]);
        });
    }



    searchItemTypes(searchFilter: SearchFilter): void {
        this.managementStore.dispatch.searchItemTypes(searchFilter);
    }



    updateItemType(tag: string, updates: any, dispatchReload: boolean): Observable<boolean> {
        this.api.updateItemType(tag, updates).subscribe();
        // this.managementStore.dispatch.updateItemType(tag, updates, dispatchReload);
        this.updateItemType$.next(dispatchReload);
        return this.updateItemType$.pipe(take(1));
    }



    openAddDialog(): void {
        this.managementStore.dispatch.openAddItemTypeDialog();
    }



    deleteItemType(itemType: ItemType): void {
        this.api.deleteItemType(itemType.tag).subscribe();
        // this.managementStore.dispatch.deleteItemType(itemType);
    }


    startProgressBar(): void {
        this.managementStore.dispatch.startLoading();

    }
    stopProgressBar(): void {
        this.managementStore.dispatch.stopLoading();
    }
}
